import React from "react";

export default function NewsPage() {
  return (
    <main className="main-content">
      <h2 style={{ marginTop: 18 }}>News</h2>

      <div style={{ marginTop: 12, lineHeight: 1.6 }}>
        <div style={{ border: "1px solid rgba(212,175,55,0.35)", borderRadius: 12, padding: 12 }}>
          <b>Dec 28 2025:</b><br />
          We got our first outside submission, and it's a DOOZY!<br/>
          A fantastic version of Tango Till They're Sore by One plus One and the Cycists.<br />
          If you haven't heard it yet, check it out!<br />
        </div>
      </div>
      <div style={{ marginTop: 12, lineHeight: 1.6 }}>
        <div style={{ border: "1px solid rgba(212,175,55,0.35)", borderRadius: 12, padding: 12 }}>
          <b>Dec 24 2025:</b><br/>
          The repository is live — submit your cover!<br />
          After lots of hard work it has finally come to life!<br />
        </div>
      </div>
    </main>
  );
}
